import { NodeStates, StateProviders } from '@candulabs/core';

import { TooltipPlacement } from '@candu-ai/placement/types';
import { Action, Conditional } from 'craft/types';
import { Media } from 'craft/types/media';

export interface ContentData {
  actions?: Action[];
  custom?: Record<string, unknown>;
  conditionals?: Record<string, Conditional>;
  media?: Media;
  displayName?: string;
}

export interface VariableLocation {
  type: string;
  path: string;
}

// TODO-variables: This likely belongs in candulabs/core?
export interface Variable {
  location: VariableLocation;
  providerId: string;
  fallback?: string;
}

export interface ContentNode {
  type: string;
  data?: ContentData;
  props?: Record<string, number | string | boolean>;
  css?: Record<string, unknown>;
  cssSelectors?: Record<string, unknown>;
  nodes?: string[];
  states?: NodeStates;
  variables?: Record<string, Variable>;
  collections?: ContentCollection[];
}

export type DocumentPlacements = Record<string, TooltipPlacement>;

export interface ContentDocument {
  rootNodeId: string;
  nodes: Record<string, ContentNode>;
  stateProviders?: StateProviders;
  placements?: DocumentPlacements;
}

export enum CollectionTargetLocation {
  Text = 'Text',
  ActionURL = 'ActionURL',
  Image = 'Image',
}

export enum TargetLocationsEnglishNames {
  Text = 'text',
  ActionURL = 'URL',
  Image = 'Image',
}

export interface ContentCollection {
  collectionId: string;
  fieldId: string;
  targetLocation: CollectionTargetLocation;
  fallback?: string;
}
